var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1800,
    zoomAndPan: "magnify",
    viewBox: "0 0 1350 1349.999938",
    height: 1800,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e195fee19a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 135 406.367188 L 1215 406.367188 L 1215 943.632812 L 135 943.632812 Z M 135 406.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9d7391539"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 675 406.367188 L 1215 943.632812 L 135 943.632812 Z M 675 406.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "48c22b3205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.367188 L 1080 0.367188 L 1080 537.632812 L 0 537.632812 Z M 0 0.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7101e4a728"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 540 0.367188 L 1080 537.632812 L 0 537.632812 Z M 540 0.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d5caeb7b4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 1080,
    y: 0,
    height: 538
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e195fee19a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b9d7391539)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 135, 406)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d5caeb7b4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#48c22b3205)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7101e4a728)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 0 0.367188 L 1080.828125 0.367188 L 1080.828125 537.632812 L 0 537.632812 Z M 0 0.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.6292cbc4c7f000e9d8a9c00e0f0c8016.svg";
export { ForwardRef as ReactComponent };